import { createLucideIcon } from 'lucide-react';

// Katana uses the same 24px grid and stroke defaults as the Lucide icon set.
export const DojoIcon = createLucideIcon('DojoKatana', [
  ['path', { d: 'M7 16C12 13 17 7 20 2c0 7-5 13-11 16', key: 'blade' }],
  ['path', { d: 'm5 14 6 6M7 17l-4 4-1-1 4-4', key: 'guard-grip' }],
]);
